import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
  Chip,
} from '@mui/material';
import {
  LinkedIn,
  Twitter,
  GitHub,
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.dark',
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              INTELLUSIA STUDIOS
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Empowering government agencies and enterprises with innovative technology solutions.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
              <Chip 
                label="NAIC 541511" 
                size="small" 
                sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}
              />
              <Chip 
                label="NAIC 541513" 
                size="small" 
                sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}
              />
              <Chip 
                label="NAIC 541614" 
                size="small" 
                sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}
              />
            </Box>
            <Box>
              <IconButton 
                sx={{ color: 'white' }}
                href="https://www.linkedin.com/company/intellusia-studios"
                target="_blank"
                aria-label="LinkedIn"
              >
                <LinkedIn />
              </IconButton>
              <IconButton 
                sx={{ color: 'white' }}
                href="https://twitter.com"
                target="_blank"
                aria-label="Twitter"
              >
                <Twitter />
              </IconButton>
              <IconButton
                sx={{ color: 'white' }}
                href="https://github.com/Scriptstudio8"
                target="_blank"
                aria-label="GitHub"
              >
                <GitHub />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Services
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/services/custom-software')}
              >
                Custom Software
              </Link>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/services/managed-it')}
              >
                Managed IT
              </Link>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/services/logistics')}
              >
                Logistics Consulting
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Knowledge
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/knowledge/blog')}
              >
                Blog
              </Link>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/knowledge/case-studies')}
              >
                Case Studies
              </Link>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/capability-statement')}
              >
                Capability Statement
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/about')}
              >
                About Us
              </Link>
              {/* <Link
                color="inherit"
                underline="hover"
                sx={{ cursor: 'pointer' }}
              >
                Partners
              </Link> */}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email fontSize="small" />
                <Typography variant="body2">
                  support@scriptstudio8.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone fontSize="small" />
                <Typography variant="body2">
                  (916) 660-3509
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                <LocationOn fontSize="small" />
                <Typography variant="body2">
                  Washington
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <Typography variant="body2">
            © {currentYear} Intellusia Studios. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Privacy Policy
            </Link>
            <Link color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Terms of Service
            </Link>
            <Link color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Security
            </Link>
            <Link color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
              Compliance
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;